import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Breadcrumbs, Link, Typography } from '@mui/material';
import { NavigateNext as NavigateNextIcon } from '@mui/icons-material';
import GenericEntityCreator from '../../components/Common/GenericEntityCreator';

const CreateExchange: React.FC = () => {
  const navigate = useNavigate();

  const handleSuccess = (createdEntity: any) => {
    console.log('Exchange created:', createdEntity);
    navigate('/exchanges');
  };

  const handleCancel = () => {
    navigate('/exchanges');
  };

  return (
    <Box>
      {/* Breadcrumbs */}
      <Breadcrumbs
        separator={<NavigateNextIcon fontSize="small" />}
        sx={{ mb: 3 }}
      >
        <Link
          color="inherit"
          href="/exchanges"
          onClick={(e) => {
            e.preventDefault();
            navigate('/exchanges');
          }}
        >
          Exchange Management
        </Link>
        <Typography color="text.primary">Create Exchange</Typography>
      </Breadcrumbs>

      {/* Generic Entity Creator */}
      <GenericEntityCreator
        entityType="exchange"
        onSuccess={handleSuccess}
        onCancel={handleCancel}
      />
    </Box>
  );
};

export default CreateExchange;

